export default __webpack_public_path__ + "static/media/experience3.d03c6b90.png";